<div>
  <h4 class="title">Customer Invites <ion-icon name="close" (click)="onDismiss()"></ion-icon></h4>
  <div>
  </div>
</div>
